module.exports = __webpack_public_path__ + "static/media/refresh-button.6b5a22be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/MainPanel/components/TablePart/assets/refresh-button.svg
// module id = 1961
// module chunks = 0